import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              羞羞漫画
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专注于成人向漫画内容的正版阅读平台，海量独家漫画资源，支持多端同步阅读，每日更新不间断。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">全部漫画</Link></li>
              <li><Link to="/category/lianzai" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">连载中</Link></li>
              <li><Link to="/category/wanjie" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">已完结</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/aiqing" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">恋爱漫画</Link></li>
              <li><Link to="/category/xuanhuan" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">玄幻漫画</Link></li>
              <li><Link to="/category/dushi" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">都市漫画</Link></li>
              <li><Link to="/category/kehuan" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">科幻漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><a href="/about#contact" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">联系我们</a></li>
              <li><span className="text-sm text-foreground-600">客服邮箱：kefu@xiuxiumanhua.com</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 羞羞漫画 - 正版授权漫画平台 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}